// extracted by mini-css-extract-plugin
export default {"mainContainer":"CustomerOrders_mainContainer__Acr1H","backButton":"CustomerOrders_backButton__r+jt3","heading":"CustomerOrders_heading__TcpLy","card":"CustomerOrders_card__JRq4z"};